//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import config from '@/config'
import { uploadFile } from '@/api/yuangongquan'
import timeimg from '@//assets/yiliaohuzhu/time.png'
import axios from 'axios'
import { Form, Field, Cell, Button, Popup, Picker, DatetimePicker, Uploader, Toast } from 'vant'
import { getUserInfo, getcheckList, getcost, editList, getMyMedicalBase } from '@/api/yiliaohuzhu'
export default {
  name: 'createList',
  components: {
    vanForm: Form,
    vanField: Field,
    vanButton: Button,
    vanCell: Cell,
    vanPopup: Popup,
    vanPicker: Picker,
    vanDatetimePicker: DatetimePicker,
    vanUploader: Uploader
  },
  props: {},
  data () {
    return {
      id: this.$route.params.id,
      timeimg: timeimg,
      name: '', // 姓名
      sextext: '', // 性别
      sex: '',
      age: '', // 年龄
      phoneNumber: '', // 手机号码
      idCard: '', // 身份证
      city: '', // 地市
      cityid: '',
      county: '', // 区县
      countyid: '',
      medicalTypetext: '', // 申请补助类别
      medicalType: '',
      bzvaluetext: '', // 病种名称
      bzvalue: '', // 病种名称
      bzname: '', // 所患病名
      stpaynf: '', // 起始交费年份
      outtime: '', // 出院时间
      sftypetext: '', // 身份性质
      sftype: '', // 身份性质
      company: '', // 单位
      comtypetext: '', // 单位类别
      comtype: '', // 单位类别
      payee: '', // 收款人
      cost: '', // 补助金额
      banknum: '', // 收款银行卡号
      appreason: '', // 申请补助理由
      pathid: [], // 费用结算单
      pathid1: [], // 发票
      pathid2: [], // 出院记录
      pathid3: [], // 病理检查报告单
      showsex: false,
      showcity: false,
      showcounty: false,
      showtype: false,
      showbz: false,
      shownf: false,
      showcy: false,
      showsf: false,
      showdw: false,
      sexList: [{ text: '男', value: 1 }, { text: '女', value: 2 }],
      cityList: [],
      countyList: [{ key: '', value: '请选择' }],
      typeList: [{ text: '重病', value: 1 }, { text: '大病', value: 2 }],
      bzList: [{ key: '', value: '请选择' }],
      sfList: [{ text: '合同用工', value: 1 }, { text: '劳务派遣', value: 2 }, { text: '退休', value: 3 }, { text: '退养', value: 4 }, { text: '其他人员', value: 5 }],
      dwList: [{ text: '邮政', value: 1 }, { text: '中邮保险', value: 2 }, { text: '速递', value: 3 }],
      checkitem: {
        isname: true,
        issex: true,
        isage: true,
        isphoneNumber: true,
        isidCard: true,
        iscity: false,
        iscounty: false,
        ismedicalType: false,
        isbzvalue: false,
        isbzname: false,
        isstpaynf: true,
        isouttime: false,
        issftype: true,
        iscompany: true,
        iscomtype: true,
        ispayee: false,
        iscost: true,
        isbanknum: false,
        isappreason: false
      },
      imglist: [],
      imglist1: [],
      imglist2: [],
      imglist3: []
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    },
    userid () {
      return this.$store.state.user.userid
    }
  },
  created () { },
  mounted () {
    // this.getUser()
    // this.getcitylist()
    this.getinfor()
    // this.getbzlist()
    // this.getList()
  },
  methods: {
    getinfor () {
      getMyMedicalBase({
        ids: this.id
      }).then(data => {
        this.name = data.obj.name
        this.sextext = data.obj.sexname
        this.sex = data.obj.sex
        this.age = data.obj.age
        this.idCard = data.obj.idCard
        this.phoneNumber = data.obj.phoneNumber
        this.stpaynf = data.obj.stpaynf
        this.company = data.obj.company
        this.comtype = data.obj.comtype
        this.bzname = data.obj.bzname
        this.comtypetext = data.obj.comtypename
        this.payee = data.obj.payee
        this.cost = data.obj.cost
        this.banknum = data.obj.banknum
        this.appreason = data.obj.appreason
        this.outtime = data.obj.outtime
        this.medicalType = data.obj.medicalType
        this.medicalTypetext = data.obj.medicalTypeName
        this.imglist = data.obj.pathid.split(',')
        this.imglist1 = data.obj.pathid1.split(',')
        this.imglist2 = data.obj.pathid2.split(',')
        this.imglist3 = data.obj.pathid3.split(',')
        data.obj.paths.forEach(el => {
          this.pathid.push({ url: config.baseUrl + el })
        })
        data.obj.paths1.forEach(el => {
          this.pathid1.push({ url: config.baseUrl + el })
        })
        data.obj.paths2.forEach(el => {
          this.pathid2.push({ url: config.baseUrl + el })
        })
        data.obj.paths3.forEach(el => {
          this.pathid3.push({ url: config.baseUrl + el })
        })
        this.cityid = data.obj.cityid
        this.countyid = data.obj.countyid
        this.sftype = data.obj.sftype
        this.sftypetext = data.obj.sftypename
        this.bzvalue = data.obj.bzvalue
        this.bzvaluetext = data.obj.bzvaluename
        this.getcitylist()
      })
    },
    onSubmit (values) {
      console.log('submit', values)
      let formdata = values
      formdata.pathid = this.imglist.join(';')
      formdata.pathid1 = this.imglist1.join(';')
      formdata.pathid2 = this.imglist2.join(';')
      formdata.pathid3 = this.imglist3.join(';')
      formdata.sex = this.sex
      formdata.bzvalue = this.bzvalue
      formdata.cityid = this.cityid
      formdata.countyid = this.countyid
      formdata.comtype = this.comtype
      formdata.medicalType = this.medicalType
      formdata.sftype = this.sftype
      formdata.id = this.id
      formdata.accountId = this.accountid
      console.log(formdata)
      editList(formdata).then(res => {
        if (res.success) {
          Toast('修改成功')
          this.$router.push({ name: 'yiliaohuzhuHome' })
        }
      })
    },
    checkchange () {
      if (this.medicalType == '') {
        return
      }
      if (this.outtime == '') {
        return
      }
      if (this.bzvalue == '') {
        return
      }
      if (this.stpaynf == '') {
        return
      }
      if (this.sftype == '') {
        return
      }
      getcost({
        medicalType: this.medicalType,
        outtime: this.outtime,
        bzvalue: this.bzvalue,
        stpaynf: this.stpaynf,
        sftype: this.sftype,
        idCard: this.idCard
      }).then(data => {
        this.cost = data.obj.cost
      })
    },
    // 获取地市
    getcitylist () {
      axios.get('http://www.zjftu.org/youzheng/sysDd/FTU_WXCP_DEPARTNEW.action?plistvalue=1').then(res => {
        this.cityList = res.data
        this.cityList.forEach(element => {
          if (this.cityid == element.key) {
            this.city = element.value
            this.getcounty(this.cityid)
          }
        })
      })
    },
    // 获取区县
    getcounty (id) {
      if (id == '') {
        this.county = ''
        this.countyList = [{ key: '', value: '请选择' }]
      } else {
        axios.get('http://www.zjftu.org/youzheng/sysDd/FTU_WXCP_DEPARTNEW.action', {
          params: {
            plistvalue: id
          }
        }).then(res => {
          this.countyList = res.data
          if (this.countyid) {
            this.countyList.forEach(element => {
              if (this.countyid == element.key) {
                this.county = element.value
              }
            })
          }
        })
      }
    },
    // 获取病种名称
    getbzlist () {
      axios.get('http://www.zjftu.org/youzheng/sysDd/FTU_MEDICAL_BZTYPE.action', {
        params: {
          plistvalue: this.medicalType
        }
      }).then(res => {
        this.bzList = res.data
      })
    },
    // 获取身份证
    getUser () {
      getUserInfo({
        userid: this.userid
      }).then(res => {
        this.idCard = res.obj.idcard
        // this.getList()
      })
    },
    // 获取默认信息
    getList () {
      getcheckList({
        idCard: this.idCard
      }).then(data => {
        this.name = data.obj.name
        this.sextext = data.obj.sex === 1 ? '男' : '女'
        this.sex = data.obj.sex
        this.age = this.setage(this.idCard)
        this.phoneNumber = data.obj.phoneNumber
        this.stpaynf = data.obj.joinTime
        this.company = data.obj.unitName
        this.comtype = data.obj.unitCategory
        this.dwList.forEach(element => {
          if (data.obj.unitCategory == element.value) {
            this.comtypetext = element.text
          }
        })
        this.sftype = data.obj.employmentNature
        this.sfList.forEach(element => {
          if (data.obj.employmentNature == element.value) {
            this.sftypetext = element.text
          }
        })
      })
    },
    setage (identityCard) {
      var len = (identityCard + '').length
      if (len == 0) {
        return 0
      } else {
        if ((len != 15) && (len != 18))// 身份证号码只能为15位或18位其它不合法
        {
          return 0
        }
      }
      var strBirthday = ''
      if (len == 18)// 处理18位的身份证号码从号码中得到生日和性别代码
      {
        strBirthday = identityCard.substr(6, 4) + '/' + identityCard.substr(10, 2) + '/' + identityCard.substr(12, 2)
      }
      if (len == 15) {
        strBirthday = '19' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2)
      }
      // 时间字符串里，必须是“/”
      var birthDate = new Date(strBirthday)
      var nowDateTime = new Date()
      var age = nowDateTime.getFullYear() - birthDate.getFullYear()
      // 再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
      if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
        age--
      }
      return age
    },
    onConfirmsex (v) {
      this.sextext = v.text
      this.sex = v.value
      this.showsex = false
    },
    onConfirmcity (v) {
      this.cityid = v.key
      if (v.key != '') {
        this.city = v.value
      } else {
        this.city = ''
      }
      this.county = ''
      this.countyid = ''
      this.countyList = [{ key: '', value: '请选择' }]
      this.getcounty(v.key)
      this.showcity = false
    },
    onConfirmcounty (v) {
      if (v.key != '') {
        this.county = v.value
      }
      this.countyid = v.key
      this.showcounty = false
    },
    onConfirmtype (v) {
      this.medicalTypetext = v.text
      this.medicalType = v.value
      this.bzvaluetext = ''
      this.bzvalue = ''
      this.getbzlist()
      this.showtype = false
      this.checkchange()
    },
    onConfirmbz (v) {
      if (v.key != '') {
        this.bzvaluetext = v.value
      }
      this.bzvalue = v.key
      this.showbz = false
      this.checkchange()
    },
    onConfirmnf (time) {
      let date = new Date(time)
      this.stpaynf = date.getFullYear() + '-' + ((date.getMonth() + 1) <= 9 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '-' + (date.getDate() <= 9 ? '0' + date.getDate() : date.getDate())
      this.shownf = false
      this.checkchange()
    },
    onConfirmcy (time) {
      let date = new Date(time)
      this.outtime = date.getFullYear() + '-' + ((date.getMonth() + 1) <= 9 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '-' + (date.getDate() <= 9 ? '0' + date.getDate() : date.getDate())
      this.showcy = false
      this.checkchange()
    },
    onConfirmsf (v) {
      this.sftype = v.value
      this.sftypetext = v.text
      this.showsf = false
      this.checkchange()
    },
    onConfirmdw (v) {
      this.comtype = v.value
      this.comtypetext = v.text
      this.showdw = false
    },
    formatter (type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      } else if (type === 'day') {
        return `${val}日`
      }
      return val
    },
    read0 (item) {
      let formData = new FormData()
      formData.append('file', item.file)
      uploadFile(formData).then(data => {
        this.imglist.push(data.obj[0].id)
      })
    },
    delete0 (item, detail) {
      this.imglist.splice(detail.index, 1)
      return 1
    },
    read1 (item) {
      let formData = new FormData()
      formData.append('file', item.file)
      uploadFile(formData).then(data => {
        this.imglist1.push(data.obj[0].id)
      })
    },
    delete1 (item, detail) {
      this.imglist1.splice(detail.index, 1)
      return 1
    },
    read2 (item) {
      let formData = new FormData()
      formData.append('file', item.file)
      uploadFile(formData).then(data => {
        this.imglist2.push(data.obj[0].id)
      })
    },
    delete2 (item, detail) {
      this.imglist2.splice(detail.index, 1)
      return 1
    },
    read3 (item) {
      let formData = new FormData()
      formData.append('file', item.file)
      uploadFile(formData).then(data => {
        this.imglist3.push(data.obj[0].id)
      })
    },
    delete3 (item, detail) {
      this.imglist3.splice(detail.index, 1)
      return 1
    }
  }
}
